// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg[data-v-ae78c1cc]{position:relative;background:#fff;overflow:auto}.bg[data-v-ae78c1cc],.twoType[data-v-ae78c1cc]{width:100%;height:100%}.myrenderer[data-v-ae78c1cc]{height:100%}", ""]);
// Exports
module.exports = exports;
